export enum AddressEntryMaxLengths {
  CONTACT_STATE = 2,
  CONTACT_PHONE_NUMBER = 20,
  CONTACT_FAX_NUMBER = 20,
  MAD_CODE = 11,
}
